import { Link } from "react-router-dom";
import { Images } from "assets";
import { routeConstant } from "shared/routes/routeConstant";
import styles from "./style.module.scss";

// Public landing page for the welcome email's walkthrough link; reachable signed in or out.
const PortalWalkthrough = () => {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img
          src={Images.Logo}
          alt="Tracy's Custom Home Designs"
          className={styles.logo}
        />

        <div className={styles.badge}>Client Portal Walkthrough</div>

        <div className={styles.player}>
          <span className={styles.playIcon}>&#9654;</span>
        </div>

        <h1 className={styles.title}>Video Coming Soon</h1>
        <p className={styles.body}>
          We're putting the finishing touches on a short walkthrough that shows
          you around your portal — tracking your project, submitting revisions,
          and uploading inspiration. Check back shortly.
        </p>
        <p className={styles.body}>
          In the meantime, you can sign in and start exploring. Any questions,
          our team is happy to help.
        </p>

        <Link to={routeConstant.login.path} className={styles.cta}>
          Go to Login
        </Link>
      </div>

      <p className={styles.footer}>
        Tracy's Custom Home Designs — We Design Homes, Not Houses
      </p>
    </div>
  );
};

export default PortalWalkthrough;
